import * as React from "react";
import * as cn from "classnames";

const styles = require("./DialogTitleBar.less");

interface DialogTitleProps {
    title: string;
    actions?: React.ReactElement<any>;
    className?: string;
}

export const DialogTitleBar: React.SFC<DialogTitleProps> = ({title, actions, className}) => {
    return <div className={cn(styles.titleBar, className)}>
        <div className={styles.title}>
            <h1>{title}</h1>
        </div>
        <div className={styles.actions}>
           {actions}
        </div>
    </div>;
};

export default DialogTitleBar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DialogLayout/Custom/DialogTitleBar.tsx